import { Notifications } from "@kraaft/shared/core/modules/notifications/notifications";
import { OneSignalNotifications } from "@kraaft/shared/core/modules/notifications/onesignal.notifications";

export const notifications: Notifications = new OneSignalNotifications();
